import TextBox from "components/TextBox";
import MasterPage2Column from "pages/MasterPage2Column"
import * as urls from "../../../../src/api/urls";
import { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import AppSimpleBar from "components/AppSimpleBar";
import Loader from "components/Loader";
import DatePicker from "react-datepicker";
import classnames from "classnames";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import LoadingIconWithText from "components/LoadingIconWithText";
import { QuickReplyContentTypes as Types } from "const";
import MasterPage1Column from "pages/MasterPage1Column";
import Select, { components, useStateManager } from 'react-select';
import { useRedux } from "hooks";
import { createSelector } from "reselect";


interface SearchKeyword {
  groupName?: string,
  province?: string,
  sale?: string,
  cs?: string,
  inGroup?: string,
  notInGroup?: string
}

const ChatRoomList: React.FC<
  { onClickItem(editId: number | null): void, editId: number, isSearching: boolean, groupChat: any[], totalGroup: number, onSearch(keyword: SearchKeyword): void, canEdit: boolean }> =
  ({ onClickItem, editId, isSearching, groupChat, onSearch, canEdit, totalGroup }) => {
    const [keyword, setKeyword] = useState<SearchKeyword>({});
    const [lastSyncDate, setLastSyncDate] = useState<string>("");
    const [ddlUser, setDdlUser] = useState<any[]>([]);
    const [userToAddRemove, setUserToAddRemove] = useState<any[]>([]);

    // useEffect(()=>{
    //   console.log('userToAddRemove:', userToAddRemove);
    // }, [userToAddRemove]);

    useEffect(() => {
      const rs = new APIClient().fnPostForm(urls.GET_LAST_SALE_CS_SYNC_TO_GROUP_DATE, {})
        .then(rs => {
          if (rs.err) setLastSyncDate(rs.err);
          else setLastSyncDate(rs.lastSyncDate ? Utils.GetDMYHHMM(rs.lastSyncDate) : "N/A");
        })
        .catch(er => {
          setLastSyncDate(Utils.GetMessageFromExecption(er));
        });
    }, []);

    useEffect(() => {
      const rs = new APIClient().fnPostForm(urls.SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL, {})
        .then(rs => {
          // console.log('SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL:', rs);
          setDdlUser(rs);
        })
        .catch(er => Utils.HandleException(er, true));
    }, []);

    const onRemoveUserClick = (isAdd: boolean) => {
      try {
        if (userToAddRemove.length <= 0) {
          alert('ยังไม่ได้เลือก สมาชิกที่จะ' + (isAdd ? 'เพิ่ม' : 'เอาออก'));
          return;
        }
        if (groupChat.length <= 0) {
          alert('ไม่มีห้องแชทในตาราง');
          return;
        }

        const memberIDs = userToAddRemove.map(x => x.value).join(',');
        const groupIDs = groupChat.map(x => x.groupId).join(',');

        const names = userToAddRemove.map(x => '- ' + x.label).join("<br/>");
        const confirm = isAdd ?
          `ต้องการดึง <br/><span class="text-primary">${names}</span><br/>เข้าห้องแชทที่แสดงในตาราง (${groupChat.length} ห้อง) ใช่หรือไม่?` :
          `ต้องการเอา <br/><span class="text-danger">${names}</span><br/>ออกจากห้องที่แสดงในตาราง (${groupChat.length} ห้อง) ใช่หรือไม่?`


        Utils.SweetConfirm(confirm)
          .then(rs => {
            if (rs.isConfirmed) {
              new APIClient().fnPostForm(urls.SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_APPLY, {
                isAdd: isAdd,
                memberIds: memberIDs,
                groupIds: groupIDs
              })
                .then(rs => { onSearch(keyword) })
                .catch(e2 => Utils.HandleException(e2, true));
            }
          });
      } catch (e) {
        Utils.HandleException(e, true);
      }
    }

    const [groupCountInProvince, setGroupCountInProvince] = useState<string>("");
    useEffect(() => {
      if (!groupChat || groupChat.length === 0) {
        setGroupCountInProvince("");
        return;
      }

      // count by province
      const counts = groupChat.reduce<Record<string, number>>((acc, item) => {
        acc[item.provinceName] = (acc[item.provinceName] || 0) + 1;
        return acc;
      }, {});

      // convert to string: province1=2, province2=5
      const text = Object.entries(counts)
        .map(([province, count]) => `${province}=${count}`)
        .join(", ");

      setGroupCountInProvince(text);
    }, [groupChat]);

    // console.log('ddlUser:', ddlUser);

    return (
      <>
        <div className="mpage-2col-header">
          <div>รายชื่อห้องแชท</div>
          <div>
            {/* <button className="btn btn-sm btn-warning fz-11 pt-0 pb-0">ข้อมูล sync เมื่อ {lastSyncDate}</button> */}
            <span className="text-danger">ข้อมูล sync เมื่อ {lastSyncDate}</span>

            {/* {canEdit && (
              <button className="btn btn-pc btn-warning" onClick={() => { onClickItem(-1) }} >เพิ่มใหม่</button>
            )} */}
          </div>
        </div>
        <div className="row pb-1">
          <div className="col">
            ชื่อห้องแชท
            <TextBox className="form-control p-1" onEnter13={(e) => onSearch(keyword)} onChange={(e) => setKeyword(p => ({ ...p, groupName: e.target.value }))}></TextBox>
          </div>
          <div className="col">
            เซลล์
            <TextBox className="form-control p-1" onEnter13={(e) => onSearch(keyword)} onChange={(e) => setKeyword(p => ({ ...p, sale: e.target.value }))}></TextBox>
          </div>
          <div className="col">
            CS
            <TextBox className="form-control p-1" onEnter13={(e) => onSearch(keyword)} onChange={(e) => setKeyword(p => ({ ...p, cs: e.target.value }))}></TextBox>
          </div>
        </div>
        <div className="row pb-1">
          <div className="col">
            จังหวัด (ผสมจังหวัดได้)
            <TextBox className="form-control p-1" onEnter13={(e) => onSearch(keyword)} onChange={(e) => setKeyword(p => ({ ...p, province: e.target.value }))}></TextBox>
          </div>
          <div className="col">
            สมาชิกในห้อง
            <TextBox className="form-control p-1" onEnter13={(e) => onSearch(keyword)} onChange={(e) => setKeyword(p => ({ ...p, inGroup: e.target.value }))}></TextBox>
          </div>
          <div className="col">
            ไม่อยู่ในห้อง
            <TextBox className="form-control p-1" onEnter13={(e) => onSearch(keyword)} onChange={(e) => setKeyword(p => ({ ...p, notInGroup: e.target.value }))}></TextBox>
          </div>
        </div>
        <div className="row pb-1">
          <div className="col text-center">
            <button className="btn btn-sm btn-primary fz-11 " onClick={() => onSearch(keyword)}><i className="fas fa-search"></i> ค้นหา</button>
            &nbsp;
            &nbsp;{totalGroup > groupChat.length ? (<span className="text-info">ข้อมูลมี {totalGroup} รายการ แสดงแค่ {groupChat.length} รายการ</span>) : (<span className="text-info">พบ {totalGroup} ห้องแชท</span>)}
            <span className="text-danger ms-2" onClick={() => alert(groupCountInProvince.replaceAll(", ", "\n"))}>
              {groupCountInProvince}
            </span>
          </div>
        </div>
        {canEdit && (
          <div className="row pb-1">
            <div className="col-8">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setUserToAddRemove(e)}
                // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
                //value={item.division ? ddlDivison?.find(t => t.value === item.division) : null}
                // value={ddlDivison?.filter(x1 => selDivision.map(x => x.divisionName).includes(x1.divisionName))}
                isClearable={true}
              ></Select>
            </div>
            <div className="col">
              <button className="btn btn-sm btn-warning fz-11" onClick={() => onRemoveUserClick(true)}><i className="fas fa-plus-circle"></i> เพิ่มสมาชิก</button>
              &nbsp;
              <button className="btn btn-sm btn-danger fz-11" onClick={() => onRemoveUserClick(false)}><i className="fas fa-minus-circle"></i> เอาสมาชิกออก</button>
            </div>
          </div >
        )}
        <div className="div-table-fix-header" style={{ height: "calc(100vh - 350px)" }}>
          <table >
            <thead >
              <tr>
                <th>จังหวัด</th>
                <th>ห้องแชท</th>
                <th>Sale</th>
                <th>CS</th>
                <th>สมาชิก</th>
              </tr>
            </thead>
            <tbody>
              {!isSearching && groupChat.length <= 0 && (<tr><td align="center" colSpan={5}>ไม่มีข้อมูล</td></tr>)}
              {isSearching && (<tr><td align="center" colSpan={4}><LoadingIconWithText loadingText={""}></LoadingIconWithText> กำลังค้นหา</td></tr>)}
              {groupChat.map((grp, index) => {
                return (
                  <tr key={index}>
                    <td>{grp.provinceName}</td>
                    <td>{grp.displayName2}</td>
                    <td>{grp.saleName}</td>
                    <td>{grp.csName}</td>
                    <td>{grp.otherMember}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </>);
  }

const DataSettingGroupMember = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (p2) => ({
      isAdmin: p2.isAdmin,
    })
  );
  const { isAdmin } = useAppSelector(storeData);

  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [canEdit, setCanEdit] = useState<boolean>(false);
  const [categories, setCategories] = useState<any[]>([]);
  const [groupChat, setGroupChat] = useState<any[]>([]);
  const [totalGroup, setTotalGroup] = useState<number>(0);
  // const [editData, setEditData] = useState<tb_QuickReply | null>(null);
  const onSearch = (keyword: SearchKeyword) => {
    try {
      const api = new APIClient();
      setIsSearching(true);
      const parm = {
        groupName: keyword.groupName,
        provinceName: keyword.province,
        saleName: keyword.sale,
        csName: keyword.cs,
        inGroup: keyword.inGroup,
        notInGroup: keyword.notInGroup,
        returnAll: false
      }
      // console.log('parm:', parm);
      api.fnPostForm(urls.SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE, parm)
        .then(rs => {
          // console.log('SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE:', rs);
          setGroupChat(rs.dataSet);
          setTotalGroup(rs.totalRecord);
          // setCategories(rs.result);
          // setCanEdit(rs.canEdit);
          setIsSearching(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setIsSearching(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSearching(false);
    }
  }

  useEffect(() => {
    //onSearch();
  }, []);

  const [editId, setEditId] = useState<number | null>(null);
  const onClickItem = (editId: number | null) => {
    setEditId(editId);
    // setEditCol2Key(editId);
  }

  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
    setEditId(key);
  }


  return (
    <MasterPage1Column
      titleText="จัดการ สมาชิก (พนักงาน) ในห้องแชท"
      titleIcon="fas fa-user-friends"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<ChatRoomList onClickItem={onClickItem} editId={editId ?? -1} isSearching={isSearching} groupChat={groupChat} totalGroup={totalGroup} onSearch={onSearch} canEdit={isAdmin} />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingGroupMember;